export default "__VITE_ASSET__ef0f891f__"